import { useState, useEffect, useCallback } from "react";
import {
  Box,
  TextField,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
  Grid,
  Typography,
  MenuItem,
  Divider,
  Stepper,
  Step,
  StepLabel,
  Tooltip,
  IconButton,
} from "@mui/material";
import { Visibility as ViewIcon } from "@mui/icons-material";
import { DataGrid, Toolbar } from "@mui/x-data-grid";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import ConfirmDialog from "../components/ConfirmDialog";

// Import các API
import customerApi from "../api/customerApi";
import orderApi from "../api/orderApi";
import invoiceSupplierConfigApi from "../api/invoiceSupplierConfigApi";
import priceListApi from "../api/priceListApi";

const pageNo = "InvoiceRegistrationPage";

function InvoiceRegistrationPage() {
  const user = useSelector((state) => state.auth.user);
  const roles = useSelector((state) => state.auth.roles);
  const customerInfor = useSelector((state) => state.auth.customerInfor);

  const [loading, setLoading] = useState(false);
  const [customer, setCustomer] = useState(null);

  // --- Trạng thái Modal thêm, sửa ký hiệu ---
  const [openAddEditExtensionModal, setOpenAddEditExtensionModal] =
    useState(false);
  const [openAddEditInvoiceModal, setOpenAddEditInvoiceModal] = useState(false);
  const [formErrors, setFormErrors] = useState({});

  const [openOrderInforModal, setOpenOrderInforModal] = useState(false);
  const [currentOrder, setCurrentOrder] = useState(null);
  const [orders, setOrders] = useState([]);
  const [openQrPayment, setOpenQrPayment] = useState(false);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  const [totalRowCount, setTotalRowCount] = useState(0);
  const [confirmDialogState, setConfirmDialogState] = useState({
    open: false,
    title: "",
    content: "",
    onConfirm: () => {},
    onClose: () => {},
  });

  const [invoiceSupplierConfigs, setInvoiceSupplierConfigs] = useState([]);
  const [productGroups, setProductGroups] = useState([]);
  const [productGroup, setProductGroup] = useState("");
  const [priceList, setPriceList] = useState([]);
  const [activeStep, setActiveStep] = useState(0);
  const [isExtra, setIsExtra] = useState(false);
  const steps = ["Đơn hàng", "Thanh toán"];

  const fetchInvoiceSupplierConfig = useCallback(async (CusId) => {
    try {
      const response =
        await invoiceSupplierConfigApi.SearchInvoiceSupplierConfig(CusId);
      if (response.success) {
        setInvoiceSupplierConfigs(
          response.data.find((config) => config.IscIsActive),
        );
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error(error.message);
      console.error(error);
    } finally {
    }
  }, []);

  useEffect(() => {
    fetchInvoiceSupplierConfig(customerInfor.CusId);
  }, [fetchInvoiceSupplierConfig]);

  const fetchCustomerInfor = useCallback(async () => {
    try {
      const response = await customerApi.getCustomerInfor(customerInfor.CusId);
      if (response.success) {
        setCustomer(response.data);
      }
    } catch (error) {
      toast.error(error.message);
    }
  }, []);
  useEffect(() => {
    fetchCustomerInfor();
  }, [fetchCustomerInfor]);

  const fetchProductGroup = useCallback(async () => {
    if (invoiceSupplierConfigs === null) return;
    try {
      const response = await priceListApi.getProductGroup(
        1,
        invoiceSupplierConfigs?.EsId,
      );
      if (response.success) {
        setProductGroups(response.data);
      }
    } catch (error) {
      toast.error(error.message);
    }
  }, [invoiceSupplierConfigs]);
  useEffect(() => {
    fetchProductGroup();
  }, [fetchProductGroup]);

  const fetchOrders = useCallback(async () => {
    setLoading(true);
    try {
      const response = await orderApi.SearchCustomerOrders(
        customerInfor.CusId,
        paginationModel.page,
        paginationModel.pageSize,
        null,
      );
      if (response.success) {
        setOrders(response.data);
        setTotalRowCount(response.pagination.totalRecords);
      } else {
        setOrders([]);
        toast.error(response.message);
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  }, [customerInfor, paginationModel]);

  useEffect(() => {
    fetchOrders();
  }, [fetchOrders]);

  const fetchPriceList = useCallback(
    async (
      searchKeyword,
      page,
      pageSize,
      productType,
      supplierId,
      productGroup,
    ) => {
      setLoading(true);
      try {
        console.log(invoiceSupplierConfigs);

        console.log(
          searchKeyword,
          page,
          pageSize,
          productType,
          supplierId,
          productGroup,
        );

        const response = await priceListApi.search(
          searchKeyword,
          page,
          pageSize,
          productType,
          supplierId,
          productGroup,
        );
        if (response.success) {
          setPriceList(response.data);
        } else {
          setPriceList([]);
        }
      } catch (error) {
        toast.error(error.toString() || "Đã xảy ra lỗi khi tìm kiếm mặt hàng.");
        setPriceList([]);
      } finally {
        setLoading(false);
      }
    },
    [],
  );

  const handleCloseAddEditExtensionModal = () => {
    setOpenAddEditExtensionModal(false);
    setCurrentOrder(null);
    setFormErrors({});
    setIsExtra(false);
    setActiveStep(0);
    fetchOrders();
  };
  const handleCloseAddEditInvoiceModal = () => {
    setOpenAddEditInvoiceModal(false);
    setCurrentOrder(null);
    setFormErrors({});
    setIsExtra(false);
    setActiveStep(0);
    fetchOrders();
  };
  const handleCreateOrder = async () => {
    if (currentOrder?.priceListId == null) {
      toast.error("Vui lòng chọn gói cước");
      return;
    }
    try {
      const response = await orderApi.createOrder(
        currentOrder.orderId,
        currentOrder.orderType,
        currentOrder.priceListId,
        isExtra,
        currentOrder.note,
        currentOrder.startTime,
        customerInfor.CusId,
        user.UsId,
      );
      if (response.success) {
        setCurrentOrder(response.data);
        setActiveStep(1);
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };
  const handleEditOrder = async (orderId) => {
    try {
      const response = await orderApi.getOrderInfor(orderId);
      if (response.success) {
        setCurrentOrder(response.data);
        setOpenOrderInforModal(true);
      } else {
        toast.error("Lỗi lấy thông tin đơn hàng. Vui lòng thử lại sau.");
      }
    } catch (error) {
      toast.error(error.message);
    }
  };
  const handleCloseOrderInforModal = () => {
    setOpenOrderInforModal(false);
    fetchOrders();
    fetchCustomerInfor();
  };
  const columns = [
    {
      field: "createdAt",
      headerName: "Ngày tạo",
      headerAlign: "center",
      width: 160,
      align: "center",
      valueFormatter: (params) => {
        return dayjs(params).format("DD/MM/YYYY");
      },
    },
    {
      field: "productName",
      headerName: "Sản phẩm",
      headerAlign: "center",
      width: 350,
    },
    {
      field: "quantity",
      headerName: "Số lượng",
      headerAlign: "center",
      align: "right",
      width: 120,
    },
    {
      field: "endTime",
      headerName: "Hạn sử dụng",
      headerAlign: "center",
      align: "center",
      width: 120,
      valueFormatter: (params) => {
        return params ? dayjs(params).format("DD/MM/YYYY") : "";
      },
    },
    {
      field: "orderStatusText",
      headerName: "Trạng thái",
      headerAlign: "center",
      align: "center",
      width: 120,
    },
    {
      field: "isPaidText",
      headerName: "Thanh toán",
      headerAlign: "center",
      align: "center",
      width: 150,
    },
    {
      field: "downloadLink",
      headerName: "Tải đơn hàng",
      headerAlign: "center",
      align: "center",
      width: 120,
    },
    {
      field: "UsFullNameCreate",
      headerName: "Người tạo",
      headerAlign: "center",
      align: "center",
      width: 150,
    },
    {
      field: "UsFullNameApprove",
      headerName: "Người duyệt",
      headerAlign: "center",
      align: "center",
      width: 150,
    },
    {
      field: "actions",
      headerName: "Chức năng",
      headerAlign: "center",
      type: "actions",
      width: 90,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <Box>
          <Tooltip title="Xem đơn hàng">
            <IconButton
              color="primary"
              size="small"
              onClick={() => handleEditOrder(params.row.orderId)}
            >
              <ViewIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Box>
      ),
    },
  ];

  const handleOpenExtensionModal = async () => {
    try {
      let customerData = null;
      const reCustomer = await customerApi.getCustomerInfor(
        customerInfor.CusId,
      );
      if (reCustomer.success) {
        customerData = reCustomer.data;
      }
      const response = await orderApi.getLastOrder(customerInfor.CusId, 1);
      if (response.success) {
        if (response.data === null) {
          setIsExtra(true);
        } else {
          setIsExtra(false);
        }
      }
      setCurrentOrder({
        orderId: null,
        orderCode: null,
        productGroupNo: "",
        productGroupName: "",
        productName: "",
        unitName: "",
        unitPrice: 0,
        quantity: 0,
        itemAmount: 0,
        discountPercent: 0,
        discountAmount: 0,
        vatPercent: 0,
        vatAmount: 0,
        extraAmount: 0,
        totalAmount: 0,
        priceListId: null,
        orderType: 0,
        startTime: customerData.CusExpiredDate
          ? dayjs(customerData.CusExpiredDate)
          : dayjs(),
        endTime: null,
        note: "",
      });
      await fetchPriceList("", 0, 100, 0, null, null);
      setOpenAddEditExtensionModal(true);
    } catch (error) {
      toast.error(error.message);
    }
  };
  const handleOpenInvoiceModal = async () => {
    if (
      invoiceSupplierConfigs?.EsName === null ||
      invoiceSupplierConfigs?.EsName === ""
    ) {
      toast.warning("Vui lòng cấu hình nhà cung cấp hóa đơn.");
      return;
    }
    try {
      let customerData = null;
      const reCustomer = await customerApi.getCustomerInfor(
        customerInfor.CusId,
      );
      if (reCustomer.success) {
        customerData = reCustomer.data;
      }
      const response = await orderApi.getLastOrder(customerInfor.CusId, 1);
      if (response.success) {
        if (response.data === null) {
          setIsExtra(true);
        } else {
          setIsExtra(false);
        }
      }
      setCurrentOrder({
        orderId: null,
        orderCode: null,
        productGroupNo: "",
        productGroupName: "",
        productName: "",
        unitName: "",
        unitPrice: 0,
        quantity: 0,
        itemAmount: 0,
        discountPercent: 0,
        discountAmount: 0,
        vatPercent: 0,
        vatAmount: 0,
        extraAmount: 0,
        totalAmount: 0,
        orderType: 1,
        startTime: dayjs(customerData.CusExpiredDate),
        endTime: null,
        note: "",
        orderStatus: 0,
      });
      await fetchProductGroup();
      setOpenAddEditInvoiceModal(true);
    } catch (error) {
      toast.error(error.message);
    }
  };

  const handleBack = () => {
    setActiveStep((prev) => prev - 1);
  };
  const handleNext = async () => {
    if (activeStep === 0) {
      await handleCreateOrder();
    } else if (activeStep === steps.length - 1) {
      let status = await handleCheckpayTransaction();
      if (status) {
        handleCloseAddEditExtensionModal();
        handleCloseAddEditInvoiceModal();
      }
    }
  };
  const handleCheckpayTransaction = async () => {
    let success = false;
    try {
      const response = await orderApi.checkPaymentStatus(currentOrder?.orderId);
      if (response.success) {
        success = true;
        toast.success("Đã nhận được thanh toán");
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error(error.message);
    }
    return success;
  };
  const handlePaginationModelChange = (newPaginationModel) => {
    setPaginationModel(newPaginationModel);
  };
  const handlePaymentApproval = async () => {
    try {
      const check = await orderApi.checkPaymentStatus(currentOrder.orderId);
      if (check.success) {
        toast.success("Đơn hàng đã nhận được thanh toán");
        await handleEditOrder(currentOrder.orderId);
      } else {
        setConfirmDialogState({
          open: true,
          title: "Ghi nhận thanh toán cho đơn hàng",
          content:
            "Đơn hàng chưa nhận được thanh toán. Bạn có muốn tiếp tục ghi nhận thanh toán cho đơn hàng này không?",
          onConfirm: async () => {
            const response = await orderApi.handlePaymentApproval(
              currentOrder.orderId,
              user.UsId,
            );
            if (response.success) {
              toast.success("Duyệt thanh toán thành công");
              setConfirmDialogState({
                ...confirmDialogState,
                open: false,
              });
              handleCloseOrderInforModal();
            } else {
              toast.error(response.message);
            }
          },
          onClose: () =>
            setConfirmDialogState({
              ...confirmDialogState,
              open: false,
            }),
        });
      }
    } catch (error) {
      toast.error(error.message);
    }
  };
  const handleOpenQRPayment = async () => {
    setOpenQrPayment(true);
  };

  const handleCancelOrder = async () => {
    try {
      const response = await orderApi.handleCancelOrder(
        currentOrder.orderId,
        user.UsId,
      );
      if (response.success) {
        toast.success("Hủy đơn hàng thành công");
        handleCloseOrderInforModal();
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="vi">
      <Box sx={{ p: 2, flexGrow: 1, display: "flex", flexDirection: "column" }}>
        <Grid
          component="fieldset"
          sx={{ borderRadius: 3, mb: 1 }}
          size={{ xs: 12 }}
        >
          <Typography
            sx={{
              fontWeight: "bold",
              color: "text.primary",
              mb: 1,
              fontSize: 18,
            }}
          >
            Thông tin phần mềm và dịch vụ
          </Typography>
          <Grid size={{ xs: 12 }} display="flex">
            <Grid sx={{ width: "800px", mr: 1 }}>
              <Box display="flex" mb={1}>
                <Typography
                  sx={{
                    minWidth: "180px",
                    color: "text.primary",
                    ml: 1,
                    textDecoration: "underline",
                    fontWeight: "bold",
                  }}
                >
                  Số hoá đơn còn lại:
                </Typography>
                <Typography sx={{ color: "text.secondary" }}>
                  {customer?.CusInvoiceQuantityRemain}
                </Typography>
              </Box>
              <Grid sx={{ display: "flex", mb: 1 }}>
                <Grid sx={{ display: "flex", flex: 1 }}>
                  <Typography
                    sx={{
                      minWidth: "180px",
                      color: "text.primary",
                      ml: 1,
                      textDecoration: "underline",
                      fontWeight: "bold",
                    }}
                  >
                    Gói phần mềm:
                  </Typography>
                  <Typography sx={{ color: "text.secondary" }}>—</Typography>
                </Grid>
                <Grid sx={{ display: "flex", flex: 1 }}>
                  <Typography
                    sx={{
                      minWidth: "200px",
                      color: "text.primary",
                      ml: 1,
                      textDecoration: "underline",
                      fontWeight: "bold",
                    }}
                  >
                    Ngày thanh toán tiếp theo:
                  </Typography>
                  <Typography sx={{ color: "text.secondary" }}>
                    {customer?.CusExpiredDate != null
                      ? dayjs(customer?.CusExpiredDate).format("DD/MM/YYYY")
                      : "—"}
                  </Typography>
                </Grid>
              </Grid>
              <Box display="flex" mb={1}>
                <Typography
                  sx={{
                    minWidth: "180px",
                    color: "text.primary",
                    ml: 1,
                    textDecoration: "underline",
                    fontWeight: "bold",
                  }}
                >
                  Số cửa hàng:
                </Typography>
                <Typography sx={{ color: "text.secondary" }}>
                  {customer?.InvoiceSignActive}
                </Typography>
              </Box>
            </Grid>
            <Grid sx={{ width: "400px" }}>
              <Box display="flex" mb={1}>
                <Typography>
                  <i
                    style={{
                      textDecoration: "underline",
                      color: "#1976d2",
                      cursor: "pointer",
                    }}
                    onClick={handleOpenInvoiceModal}
                  >
                    Mua thêm hóa đơn
                  </i>
                </Typography>
              </Box>
              <Box display="flex" mb={1}>
                <Typography sx={{ mr: 2 }}>
                  <i
                    style={{
                      textDecoration: "underline",
                      color: "#1976d2",
                      cursor: "pointer",
                    }}
                  >
                    Xem các gói phần mềm khác
                  </i>
                </Typography>
                <Typography>
                  <i
                    style={{
                      textDecoration: "underline",
                      color: "#1976d2",
                      cursor: "pointer",
                    }}
                    onClick={handleOpenExtensionModal}
                  >
                    Gia hạn phần mềm
                  </i>
                </Typography>
              </Box>
              <Box display="flex" mb={1}>
                <Typography>
                  <i
                    style={{
                      textDecoration: "underline",
                      color: "#1976d2",
                      cursor: "pointer",
                    }}
                  >
                    Mở thêm cửa hàng
                  </i>
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Grid>
        {/* DataGrid danh sách */}
        <Box sx={{ flexGrow: 1, width: "100%", display: "flex" }}>
          <DataGrid
            rows={orders}
            columns={columns}
            rowCount={totalRowCount}
            pageSizeOptions={[10, 20, 50, 100]}
            paginationMode="server"
            paginationModel={paginationModel}
            onPaginationModelChange={handlePaginationModelChange}
            disableRowSelectionOnClick
            loading={loading}
            getRowId={(row) => row.orderId}
            showCellVerticalBorder
            showColumnVerticalBorder
            showToolbar
            slots={{
              toolbar: () => (
                <Toolbar sx={{ minHeight: 40 }}>
                  <Typography
                    sx={{ flex: "1 1 100%", marginLeft: "10px" }}
                    variant="h6"
                  >
                    Thông tin đơn hàng
                  </Typography>
                </Toolbar>
              ),
              noRowsOverlay: () => (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%",
                  }}
                >
                  Không có đơn hàng nào.
                </Box>
              ),
            }}
          />
        </Box>
        <Dialog open={openAddEditExtensionModal} maxWidth="sm" fullWidth>
          <DialogTitle>Đăng ký gia hạn phần mềm</DialogTitle>
          <Divider />
          <DialogContent>
            <Stepper activeStep={activeStep} alternativeLabel sx={{ mb: 3 }}>
              {steps.map((label, index) => (
                <Step key={index}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>
            <Box>
              {activeStep === 0 && (
                <Box display="flex" flexDirection="column" gap={2}>
                  <Grid sx={{ display: "flex" }}>
                    <TextField
                      select
                      label="Gói cước"
                      value={currentOrder?.priceListId || 0}
                      onChange={(e) => {
                        let price = priceList.find(
                          (option) => option.priceListId === e.target.value,
                        );
                        let itemAmount = price?.unitPrice * price?.quantity;
                        let vatAmount = (itemAmount * price?.vatPercent) / 100;
                        let endTime = dayjs(currentOrder.startTime).add(
                          price?.quantity,
                          "year",
                        );
                        setCurrentOrder((prev) => ({
                          ...prev,
                          priceListId: e.target.value,
                          quantity: price?.quantity,
                          unitPrice: price?.unitPrice,
                          unitName: price?.unitName,
                          productName: price?.productName,
                          itemAmount: itemAmount,
                          vatAmount: vatAmount,
                          endTime: endTime,
                          totalAmount: itemAmount + vatAmount,
                        }));
                      }}
                      size="small"
                      sx={{ width: 300 }}
                    >
                      {priceList.map((option) => (
                        <MenuItem
                          key={option.priceListId}
                          value={option.priceListId}
                        >
                          {option.productName}
                        </MenuItem>
                      ))}
                    </TextField>
                    <Typography sx={{ ml: 2, alignContent: "end" }}>
                      <strong>Số lượng:</strong> {currentOrder?.quantity}{" "}
                      {currentOrder?.unitName}
                    </Typography>
                  </Grid>
                  <Box display="flex" alignItems="center" mb={0}>
                    <Typography
                      variant="h7"
                      sx={{ minWidth: 180, textAlign: "start", mr: 1 }}
                    >
                      <strong>Ngày bắt đầu:</strong>
                    </Typography>
                    <Typography variant="h7" fullWidth>
                      {currentOrder?.startTime
                        ? dayjs(currentOrder?.startTime).format("DD/MM/YYYY")
                        : ""}
                    </Typography>
                  </Box>
                  <Box display="flex" alignItems="center" mb={0}>
                    <Typography
                      variant="h7"
                      sx={{ minWidth: 180, textAlign: "start", mr: 1 }}
                    >
                      <strong>Ngày kết thúc:</strong>
                    </Typography>
                    <Typography variant="h7" fullWidth>
                      {currentOrder?.endTime
                        ? dayjs(currentOrder?.endTime).format("DD/MM/YYYY")
                        : ""}
                    </Typography>
                  </Box>
                  <Box display="flex" alignItems="center" mb={0}>
                    <Typography
                      variant="h7"
                      sx={{ minWidth: 180, textAlign: "start", mr: 1 }}
                    >
                      <strong>Tổng tiền:</strong>
                    </Typography>
                    <Typography variant="h7" fullWidth>
                      {currentOrder?.totalAmount.toLocaleString("vi-VN")} VNĐ{" "}
                      {"(Đã bao gồm VAT)"}
                    </Typography>
                  </Box>
                </Box>
              )}
              {activeStep === 1 && (
                <Grid
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                  height={"500px"}
                >
                  {/* <Grid sx={{ backgroundColor: "red", height: 100 }}></Grid> */}
                  <Grid
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      flex: 1,
                    }}
                  >
                    <Box
                      component="iframe"
                      src={currentOrder?.qrLink}
                      title="QR Thanh toán"
                      style={{
                        border: "1px solid #ccc",
                        borderRadius: "8px",
                        height: "100%",
                        zoom: 0.75,
                        transform: "scale(0.95)",
                        width: "70%",
                      }}
                    />
                  </Grid>
                </Grid>
              )}
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseAddEditExtensionModal} color="primary">
              Đóng
            </Button>
            {activeStep > 0 && (
              <Button variant="outlined" onClick={handleBack}>
                Trở về
              </Button>
            )}
            <Button
              onClick={handleNext}
              variant="contained"
              color="primary"
              disabled={loading}
            >
              {loading ? (
                <CircularProgress size={24} color="inherit" />
              ) : activeStep === steps.length - 1 ? (
                "Thanh toán"
              ) : currentOrder?.orderId ? (
                "Cập nhật"
              ) : (
                "Tạo đơn hàng"
              )}
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog open={openAddEditInvoiceModal} maxWidth="sm" fullWidth>
          <DialogTitle>Đăng ký mua hoá đơn</DialogTitle>
          <Divider />
          <DialogContent>
            <Stepper activeStep={activeStep} alternativeLabel sx={{ mb: 3 }}>
              {steps.map((label, index) => (
                <Step key={index}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>
            {activeStep === 0 && (
              <Box display="flex" flexDirection="column" gap={2}>
                <Typography variant="h6">
                  Tổ chức truyền nhận và lưu trữ:{" "}
                  {invoiceSupplierConfigs?.EsName}
                </Typography>
                <TextField
                  select
                  label="Loại hoá đơn"
                  value={currentOrder?.productGroupNo || productGroup}
                  onChange={(e) => {
                    setProductGroup(e.target.value);
                    fetchPriceList(
                      "",
                      0,
                      100,
                      1,
                      invoiceSupplierConfigs?.EsId,
                      e.target.value,
                    );
                  }}
                  size="small"
                  sx={{ width: 300 }}
                >
                  {productGroups?.map((option) => (
                    <MenuItem
                      key={option.productGroupNo}
                      value={option.productGroupNo}
                    >
                      {option.productGroupName}
                    </MenuItem>
                  ))}
                </TextField>
                <Grid sx={{ display: "flex" }}>
                  <TextField
                    select
                    label="Gói cước"
                    value={currentOrder?.priceListId}
                    onChange={(e) => {
                      let price = priceList.find(
                        (option) => option.priceListId === e.target.value,
                      );
                      let itemAmount = price?.unitPrice * price?.quantity;
                      let vatAmount = (itemAmount * price?.vatPercent) / 100;
                      let extra = 0;
                      if (isExtra) extra = price.extraPrice;
                      setCurrentOrder((prev) => ({
                        ...prev,
                        priceListId: e.target.value,
                        quantity: price?.quantity,
                        unitPrice: price?.unitPrice,
                        unitName: price?.unitName,
                        productName: price?.productName,
                        itemAmount: itemAmount,
                        vatAmount: vatAmount,
                        extraAmount: extra,
                        totalAmount: itemAmount + vatAmount + extra,
                      }));
                    }}
                    size="small"
                    sx={{ width: 300 }}
                  >
                    {priceList.map((option) => (
                      <MenuItem
                        key={option.priceListId}
                        value={option.priceListId}
                      >
                        {option.productName}
                      </MenuItem>
                    ))}
                  </TextField>
                  <Typography sx={{ ml: 2, alignContent: "end" }}>
                    <strong>Số lượng:</strong> {currentOrder?.quantity}{" "}
                    {currentOrder?.unitName}
                  </Typography>
                </Grid>
                <Box display="flex" alignItems="center" mb={0}>
                  <Typography
                    variant="h7"
                    sx={{ minWidth: 150, textAlign: "start", mr: 1 }}
                  >
                    <strong>Phí khởi tạo lần đầu:</strong>
                  </Typography>
                  <Typography variant="h7" fullWidth>
                    {currentOrder?.extraAmount.toLocaleString("vi-VN")} VNĐ
                  </Typography>
                </Box>
                <Box display="flex" alignItems="center" mb={0}>
                  <Typography
                    variant="h7"
                    sx={{ minWidth: 150, textAlign: "start", mr: 1 }}
                  >
                    <strong>Tổng tiền:</strong>
                  </Typography>
                  <Typography variant="h7" fullWidth>
                    {currentOrder?.totalAmount.toLocaleString("vi-VN")} VNĐ{" "}
                    {"(Đã bao gồm VAT và phí khởi tạo)"}
                  </Typography>
                </Box>
              </Box>
            )}
            {activeStep === 1 && (
              <Grid
                sx={{
                  display: "flex",
                  flexDirection: "column",
                }}
                height={"500px"}
              >
                {/* <Grid sx={{ backgroundColor: "red", height: 100 }}></Grid> */}
                <Grid
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    flex: 1,
                  }}
                >
                  <Box
                    component="iframe"
                    src={currentOrder?.qrLink}
                    title="QR Thanh toán"
                    style={{
                      border: "1px solid #ccc",
                      borderRadius: "8px",
                      height: "100%",
                      zoom: 0.75,
                      transform: "scale(0.95)",
                      width: "70%",
                    }}
                  />
                </Grid>
              </Grid>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseAddEditInvoiceModal} color="primary">
              Đóng
            </Button>
            {activeStep > 0 && (
              <Button variant="outlined" onClick={handleBack}>
                Trở về
              </Button>
            )}
            <Button
              onClick={handleNext}
              variant="contained"
              color="primary"
              disabled={loading}
            >
              {loading ? (
                <CircularProgress size={24} color="inherit" />
              ) : activeStep === steps.length - 1 ? (
                "Thanh toán"
              ) : currentOrder?.orderId ? (
                "Cập nhật"
              ) : (
                "Tạo đơn hàng"
              )}
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
      <Dialog open={openOrderInforModal} maxWidth="md">
        <DialogTitle>Thông tin đơn hàng</DialogTitle>
        <DialogContent>
          <Box display="flex" flexDirection="column" gap={2}>
            <Box display="flex" alignItems="center">
              <Typography
                variant="h7"
                sx={{ minWidth: 180, textAlign: "start", mr: 1 }}
              >
                <strong>Sản phẩm:</strong>
              </Typography>
              <Typography variant="h7" fullWidth>
                {currentOrder?.productName}
              </Typography>
            </Box>
            <Box display="flex" alignItems="center">
              <Typography
                variant="h7"
                sx={{ minWidth: 180, textAlign: "start", mr: 1 }}
              >
                <strong>Số lượng:</strong>
              </Typography>
              <Typography variant="h7" fullWidth>
                {currentOrder?.quantity} {currentOrder?.unitName}
              </Typography>
            </Box>
            {currentOrder?.orderType === 0 && (
              <>
                <Box display="flex" alignItems="center" mb={0}>
                  <Typography
                    variant="h7"
                    sx={{ minWidth: 180, textAlign: "start", mr: 1 }}
                  >
                    <strong>Ngày bắt đầu:</strong>
                  </Typography>
                  <Typography variant="h7" fullWidth>
                    {currentOrder?.startTime
                      ? dayjs(currentOrder?.startTime).format("DD/MM/YYYY")
                      : ""}
                  </Typography>
                </Box>
                <Box display="flex" alignItems="center" mb={0}>
                  <Typography
                    variant="h7"
                    sx={{ minWidth: 180, textAlign: "start", mr: 1 }}
                  >
                    <strong>Ngày kết thúc:</strong>
                  </Typography>
                  <Typography variant="h7" fullWidth>
                    {currentOrder?.endTime
                      ? dayjs(currentOrder?.endTime).format("DD/MM/YYYY")
                      : ""}
                  </Typography>
                </Box>
              </>
            )}

            <Box display="flex" alignItems="center" mb={0}>
              <Typography
                variant="h7"
                sx={{ minWidth: 180, textAlign: "start", mr: 1 }}
              >
                <strong>Tổng tiền:</strong>
              </Typography>
              <Typography variant="h7" fullWidth>
                {currentOrder?.totalAmount?.toLocaleString("vi-VN")}
                {" VNĐ"}
              </Typography>
            </Box>
            <Box display="flex" alignItems="center" mb={0}>
              <Typography
                variant="h7"
                sx={{ minWidth: 180, textAlign: "start", mr: 1 }}
              >
                <strong>Trạng thái thanh toán:</strong>
              </Typography>
              <Typography variant="h7" fullWidth>
                {currentOrder?.isPaid
                  ? "Đã nhận thanh toán"
                  : "Chưa nhận thanh toán"}
              </Typography>
            </Box>
            <Box display="flex" alignItems="center" mb={0}>
              <Typography
                variant="h7"
                sx={{ minWidth: 180, textAlign: "start", mr: 1 }}
              >
                <strong>Trạng thái đơn hàng:</strong>
              </Typography>
              <Typography variant="h7" fullWidth>
                {currentOrder?.orderStatus === 0
                  ? "Tạo mới"
                  : currentOrder?.orderStatus === 1
                    ? "Đã duyệt"
                    : "Đã hủy"}
              </Typography>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            onClick={() => setOpenOrderInforModal(false)}
          >
            Đóng
          </Button>
          {currentOrder?.orderStatus === 0 && (
            <>
              <Button variant="contained" onClick={handleOpenQRPayment}>
                QR thanh toán
              </Button>
              {user.UsEmail === "admini" && (
                <>
                  <Button
                    variant="contained"
                    color="error"
                    onClick={handleCancelOrder}
                  >
                    Huỷ đơn
                  </Button>
                  <Button
                    variant="contained"
                    color="success"
                    onClick={handlePaymentApproval}
                  >
                    Duyệt thanh toán
                  </Button>
                  <Button
                    color="primary"
                    variant="contained"
                    onClick={async () => {
                      setOpenOrderInforModal(false);
                      if (currentOrder?.orderType === 0) {
                        await fetchPriceList("", 0, 100, 0, null, null);
                        setOpenAddEditExtensionModal(true);
                      } else {
                        await fetchProductGroup();
                        await fetchPriceList(
                          "",
                          0,
                          100,
                          1,
                          invoiceSupplierConfigs?.EsId,
                          currentOrder?.productGroupNo,
                        );
                        setOpenAddEditInvoiceModal(true);
                      }
                    }}
                  >
                    Sửa đơn
                  </Button>
                </>
              )}
            </>
          )}
        </DialogActions>
      </Dialog>
      <Dialog open={openQrPayment} maxWidth="sm" fullWidth>
        <DialogTitle>QR thanh toán</DialogTitle>
        <DialogContent>
          <Grid
            sx={{
              display: "flex",
              flexDirection: "column",
            }}
            height={"500px"}
          >
            {/* <Grid sx={{ backgroundColor: "red", height: 100 }}></Grid> */}
            <Grid
              sx={{
                display: "flex",
                justifyContent: "center",
                flex: 1,
              }}
            >
              <Box
                component="iframe"
                src={currentOrder?.qrLink}
                title="QR Thanh toán"
                style={{
                  border: "1px solid #ccc",
                  borderRadius: "8px",
                  height: "100%",
                  zoom: 0.75,
                  transform: "scale(0.95)",
                  width: "70%",
                }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenQrPayment(false)}>Đóng</Button>
          <Button
            color="primary"
            variant="contained"
            onClick={() => handleCheckpayTransaction()}
          >
            Xác nhận
          </Button>
        </DialogActions>
      </Dialog>
      <ConfirmDialog
        open={confirmDialogState.open}
        title={confirmDialogState.title}
        content={confirmDialogState.content}
        onConfirm={confirmDialogState.onConfirm}
        onClose={confirmDialogState.onClose}
      />
    </LocalizationProvider>
  );
}

export default InvoiceRegistrationPage;
